var render, staticRenderFns
import script from "./nuxt-loading.vue?vue&type=script&lang=js&"
export * from "./nuxt-loading.vue?vue&type=script&lang=js&"
import style0 from "./nuxt-loading.vue?vue&type=style&index=0&id=41c071cf&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/royalbeeseg.com/Demo-4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('41c071cf')) {
      api.createRecord('41c071cf', component.options)
    } else {
      api.reload('41c071cf', component.options)
    }
    
  }
}
component.options.__file = ".nuxt/components/nuxt-loading.vue"
export default component.exports